module.exports = __webpack_public_path__ + "img/3.e98bdb01.jpg";